import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { AdminService } from '../../services/admin/admin.service';
import { HelpersService } from '../../../shared/servicio/helpers/helpers.service';

@Component({
  selector: 'app-state',
  templateUrl: './state.component.html',
  styleUrls: ['./state.component.css']
})
export class StateComponent implements OnInit {
  @Input() id_state: any;
  @Input() id_banner: number;
  @Output() lista = new EventEmitter<boolean>();

  constructor(
    public admin: AdminService,
    public _helper: HelpersService
  ) { }

  ngOnInit() {
  }

  update_state() {
    const newState = !this.id_state;

    // Usar el nuevo método de actualización con PATCH
    this.admin.updateBanner(this.id_banner, { active: newState }).subscribe({
      next: (response) => {
        const modalMsg = newState ? 'BANNER ACTIVADO' : 'BANNER DESACTIVADO';
        this._helper.modalSuccess(modalMsg);
        this.lista.emit(true);
      },
      error: (error) => {
        console.error('Error al actualizar estado del banner:', error);
        this._helper.modalError('Error al actualizar el estado del banner');
      }
    });
  }
}
